import React, { Component } from "react";
import * as actions from '../redux/supervisor_time_off_actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { VirtualizedTable } from '../../common/VirtualizedTable/VirtualizedTable';
import { _filterTable } from '../../common/VirtualizedTable/virtualized-table-util';

export class RequestTabContent extends Component {
    constructor(props) {
		super(props);

        let columns = [{
            label: "ID",
            dataKey: "agentId",
            width: 400
        }, {
            label: "Agent",
            dataKey: "agentName",
            width: 400
        }, {
            label: "Dates",
            dataKey: "dateRange",
            width: 400
        }, {
            label: "Hours",
            dataKey: "totalHours",
            width: 400
        }, {
            label: "Type",
            dataKey: "timeoffValue",
            width: 400
        }, {
            label: "Reason",
            dataKey: "timeoffReason",
            width: 400
        }, {
            label: "Submitted",
            dataKey: "dateCreated",
            width: 400
        }];

        this.state = {
            columns: columns,
            list: props.CurrentRequests ? props.CurrentRequests : [],
            filteredList: props.CurrentRequests ? props.CurrentRequests : [],
            selectedType: "All"
        }  

        this.generateTypeFilter = this.generateTypeFilter.bind(this);
        this.setTypeFilter = this.setTypeFilter.bind(this);
    }
    
    componentWillReceiveProps(nextProps) {
        let currReqs = JSON.stringify(this.props.CurrentRequests);
        let nextReqs = JSON.stringify(nextProps.CurrentRequests);
        if (currReqs !== nextReqs) {
            this.setState({
                list: nextProps.CurrentRequests,
                filteredList: nextProps.CurrentRequests,
                selectedType: "All"
            });
        }

        let filteredReqs = JSON.stringify(this.props.FilteredRequests);
        let nextfilteredReqs = JSON.stringify(nextProps.FilteredRequests);
        if (filteredReqs !== nextfilteredReqs) {
            this.setState({
                filteredList: nextProps.FilteredRequests,
                selectedType: "All"
            });
        }
    }

    setTypeFilter(e) {
        this.setState({ selectedType: e.target.value });
        _filterTable(e, "timeoffType", this);
    }

    generateTypeFilter() {
        let types = this.props.TimeOffEnumItems;
        if (!types || types.length === 0) return null;
        return (
            <select
                className="time-off"
                value={this.state.selectedType}
                onChange={(e) => this.setTypeFilter(e, "timeoffType", this)}>
                <option value="All">All</option>
                {
                    types.map((typeEnum, index) => <option key={index} value={typeEnum.key}>{typeEnum.value}</option>)
                }
            </select>
        );
    }
    
    render() {
        let { columns, filteredList } = this.state;
        let title = this.props.title ? this.props.title : "";
        let {User, position} = this.props
        return (
            <div className="table-container">
                <div className="status-container-title">{title}</div>
                { this.generateTypeFilter() }
                <VirtualizedTable
                    sortBy={"agentId"} 
                    columns={columns}
                    list={filteredList}
                    height={550}
                    width={500}
                    noRowsText={"There are no results that match your search. Please try again."}
                    cellRenderer={({
                            cellData,
                            columnData,
                            columnIndex,
                            dataKey,
                            isScrolling,
                            rowData,
                            rowIndex                            
                        }) => {
                            if (dataKey === "dateRange" && this.props.status !== "Canceled" && User.position !== position["superVisorReadOnly"])
                                return (
                                    <div onClick={() => this.props.editTimeOffRequestOnClick(rowData)}>
                                        <div className="edit-field">{ cellData }</div>
                                    </div>
                                )
                            if (dataKey === "totalHours")
                                return <div>{ cellData + " Hrs" }</div>;
                            return <div>{ cellData }</div>;
                        }
                    }
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        User: state.common.user,
        position: state.common.position,	  
        CurrentRequests: state.timeoff.CurrentRequests,
        FilteredRequests: state.timeoff.FilteredRequests,
        TimeOffEnumItems: state.timeoff.TimeOffEnumItems
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RequestTabContent);



// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/RequestTabContent.js